import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { Button, Modal, Form, Row, Col, Input, Alert as AntAlert } from 'antd';
import Alert from 'react-s-alert';
import Core from '../../../class/Core';

//images
import PictureNull  from '../../../images/avatar_null.png';

//actions
import * as UserActions from '../../../actions/UserActions';
import * as ManagerStatusActions from '../../../actions/StatusManagerActions.js';
import * as StatusActions from '../../../actions/StatusActions.js';
import * as RedirectActions from '../../../actions/RedirectActions';

class Perfil extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            isChangePasswordModalOpen: false,
            isSavingPassword: false
        };

        this.formRef = React.createRef();
        this.core = new Core();
    }

    componentWillMount(){
        this.props.action.showManager();
        this.props.action.redirectClear();
    }

    getPicture(){
        let data = this.props.user.foto;

        if(data !== "" && data !== null){
            return data;
        }else{
            return PictureNull;
        }
    }

    openChangePasswordModal(){
        this.setState({
            isChangePasswordModalOpen: true
        });
    }

    closeChangePasswordModal(){
        if(this.formRef.current){
            this.formRef.current.resetFields();
        }

        this.setState({
            isChangePasswordModalOpen: false
        });
    }

    submitChangePassword(){
        if(this.formRef.current){
            this.formRef.current.submit();
        }
    }

    changePassword(values){
        this.setState({
            isSavingPassword: true
        });
        this.props.action.loadingStatus();

        fetch(this.core.getUrl() + this.core.getVersionAPI() + 'usuario/alterar-senha', {
            method: 'POST',
            headers: this.core.getHeadersFetch(),
            body: JSON.stringify({
                senha_user: values.senha_user,
                senha_user_confirmation: values.senha_user_confirmation
            })
        })
            .then(this.core.responseConvert)
            .then(() => {
                Alert.success('Senha alterada com sucesso. Use a nova senha no próximo acesso.', {
                    position: 'bottom-right',
                    effect: 'slide',
                    timeout: 8000
                });
                this.closeChangePasswordModal();
            })
            .catch((err) => {
                this.core.catchFecth(err);
            })
            .finally(() => {
                this.setState({
                    isSavingPassword: false
                });
                this.props.action.loadedStatus();
            });
    }

    render(){
        if(this.props.redirect.url){
            return <Redirect to={this.props.redirect.url} />;
        }

        const isMasterLogin = this.props.user && this.props.user.is_master_login;

        return <div className="page">
            <div className="page-content">
                <h2>Perfil</h2>
                <p>Visualize as informações referente ao seu Perfil</p>

                <div className="row">
                    <div className="col-sm-3">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="image-profile" style={ { background: 'url(' + this.getPicture()+')' } }>
                                    
                                </div>
                                <h3 className="center light-font title-perfil">{this.props.user.nome}</h3>
                                <small className="center light-font">{this.props.user.config.grupo.nome}</small>
                                {!isMasterLogin &&
                                    <Button
                                        type="primary"
                                        block
                                        style={ { marginTop: 20 } }
                                        onClick={this.openChangePasswordModal.bind(this)}
                                    >
                                        ALTERAR SENHA
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-9">
                        <div className="panel">
                            <div className="panel-body">
                                <form action="" className="perfil">
                                    
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="nome">Nome</label>
                                                <h5>{this.props.user.nome}</h5>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="nome">E-mail</label>
                                                <h5>{this.props.user.email}</h5>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="nome">CPF</label>
                                                <h5>{this.props.user.doc}</h5>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="nome">Cargo</label>
                                                <h5>{this.props.user.cargo}</h5>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    title="Alterar senha"
                    open={this.state.isChangePasswordModalOpen}
                    onCancel={this.closeChangePasswordModal.bind(this)}
                    onOk={this.submitChangePassword.bind(this)}
                    okText="ALTERAR SENHA"
                    cancelText="CANCELAR"
                    confirmLoading={this.state.isSavingPassword}
                    destroyOnClose
                >
                    <AntAlert
                        type="warning"
                        showIcon
                        style={ { marginBottom: 20 } }
                        message="Atenção antes de alterar sua senha"
                        description="Ao confirmar, sua senha será alterada imediatamente. Anote a nova senha e guarde-a em um local seguro, pois ela será necessária nos próximos acessos ao sistema."
                    />
                    <Form
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.changePassword.bind(this)}
                    >
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Nova senha"
                                    name="senha_user"
                                    rules={[
                                        { required: true, message: 'Informe a nova senha.' },
                                        { min: 8, message: 'A senha deve conter no mínimo 8 caracteres.' },
                                        {
                                            pattern: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                                            message: 'A senha deve conter pelo menos 1 letra maiúscula e 1 numeral.'
                                        }
                                    ]}
                                >
                                    <Input.Password autoComplete="new-password" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Confirmar senha"
                                    name="senha_user_confirmation"
                                    dependencies={['senha_user']}
                                    rules={[
                                        { required: true, message: 'Confirme a nova senha.' },
                                        ({ getFieldValue }) => ({
                                            validator(rule, value) {
                                                if(!value || getFieldValue('senha_user') === value){
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject(new Error('A confirmação deve ser igual à nova senha.'));
                                            }
                                        })
                                    ]}
                                >
                                    <Input.Password autoComplete="new-password" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </div>
        </div>
    }
}

function mapStateProps(state, props) {
    return {
        user: state.user,
        managerStatus: state.managerStatus,
        redirect: state.redirectReducer
    }
}

function mapDispatchProps(dispatch) {
    return {
        action: bindActionCreators({
            ...UserActions,
            ...ManagerStatusActions,
            ...RedirectActions,
            ...StatusActions
        }, dispatch)
    }
}

export default withRouter(connect(mapStateProps, mapDispatchProps)(Perfil));
